import { Typography } from '@mui/material';
import { useKeycloak } from '@react-keycloak/web';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

function Redirect() {
  const navigate = useNavigate();
  const { keycloak } = useKeycloak();
  const { t } = useTranslation('login');

  const isPMO =
    keycloak.hasResourceRole('PMO', process.env.REACT_APP_KEYCLOAK_CLIENT_ID) ||
    process.env.REACT_APP_ENV === 'dev';
  const isAdmin =
    keycloak.hasResourceRole('ADMIN', process.env.REACT_APP_KEYCLOAK_CLIENT_ID) ||
    process.env.REACT_APP_ENV === 'dev';

  useEffect(() => {
    if (isPMO) {
      navigate('/pmosharing');
    } else if (isAdmin) {
      navigate('/teacherpayment');
    } else {
      navigate('/');
    }
  }, [isAdmin, isPMO, navigate]);

  return (
    <div style={{ textAlign: 'center', width: '100%' }}>
      <Typography sx={{ marginTop: '42px', marginLeft: '50px' }}>
        {t('Seu usuário não tem permissões no sistema')}
      </Typography>
    </div>
  );
}
export default Redirect;
